import { UserForm } from 'components/users/UserForm/UserForm'

export const AddUser: React.FC = () => {
  return <UserForm mode='create' />
}
